module.exports = __webpack_public_path__ + "static/media/Plan@shortened.c6c7e78e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/Plan@shortened.gif
// module id = 116
// module chunks = 0